import React from 'react';
import ReactMarkdown, { defaultUrlTransform } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import CodeBlock from './CodeBlock';

// Typography lives in .cv-markdown (chat-ui.css); overrides are kept only where behaviour differs.

const handleDownloadLinkClick = (href: string) => (e: React.MouseEvent) => {
  e.preventDefault();
  const link = document.createElement('a');
  link.href = href;
  link.download = '';
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const markdownComponents = {
  a: ({ href, children, node, ...props }: any) => (
    <a
      {...props}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={href?.startsWith('/api/chat/download/') ? handleDownloadLinkClick(href) : undefined}
    >
      {children}
    </a>
  ),
  pre: ({ children, node }: any) => {
    let language;
    if (node?.children?.[0]?.properties?.className) {
      const classes = node.children[0].properties.className as string[];
      const languageClass = classes.find((cls: string) => cls.startsWith('language-'));
      if (languageClass) language = languageClass.replace('language-', '');
    }
    return <CodeBlock language={language}>{children}</CodeBlock>;
  },
  // Wide tables scroll inside their frame instead of squashing columns or the page.
  table: ({ children, node, ...props }: any) => (
    <div className="cv-table-wrap">
      <table {...props}>{children}</table>
    </div>
  ),
};

// Model output and generated files can carry injected links, so javascript: and similar URLs are
// stripped as react-markdown does by default; inline data: images are the one addition we allow.
export const safeUrlTransform = (url: string, key: string) =>
  key === 'src' && /^data:image\//i.test(url) ? url : defaultUrlTransform(url);

const Markdown: React.FC<{ children: string }> = ({ children }) => (
  <div className="cv-markdown">
    <ReactMarkdown remarkPlugins={[remarkGfm]} urlTransform={safeUrlTransform} components={markdownComponents}>
      {children}
    </ReactMarkdown>
  </div>
);

export default Markdown;
